import React, { useEffect, useRef, useState } from "react"
import {
    Card,
    Avatar,
    Form,
    Input,
    Button,
    Typography,
    message,
    Modal
} from "antd"

import {
    LockOutlined,
    UserOutlined,
    UnlockOutlined
} from "@ant-design/icons"

import { useHistory } from "react-router-dom"
import IdleManager from "src/services/IdleManager"
import { useDispatch, useSelector } from "react-redux"
import { request } from "src/helpers/request"

const { Title, Text } = Typography

const LockScreen = () => {

    const history = useHistory()
    const Profile = useSelector(s => s?.Profile?.response?.full)

    const [loading, setLoading] = useState(false)

    const dispatch = useDispatch()

    const inputRef = useRef(null)

    useEffect(() => {

        if (inputRef.current) {
            inputRef.current.focus()
        }

    }, [])

    const verifyPassword = async (password) => {
        return request("post", "/pengaturan/profile", {
            data: { lock_password: password },
            method: "unlock"
        })
    }

    const getCallbackUrl = () => {

        const url = localStorage.getItem("lock_callback_url")
        return url || null
    }

    const onFinish = async (values) => {

        setLoading(true)


        try {
            if (Profile?.lock_screen?.require_password === 1) {
                const valid = await verifyPassword(values.password)
                if (!valid) {
                    message.error("Password salah")
                    setLoading(false)
                    return
                }
            }

            localStorage.removeItem("app_locked")
            IdleManager.resetTimer()
            const callback_url = getCallbackUrl();

            if (callback_url) {
                history.replace(callback_url)
            } else
                history.replace("/")

            localStorage.removeItem("lock_callback_url")
            // IdleManager.unlock()

        } catch (err) {
            console.log(err)
            message.error("Gagal membuka kunci")

        } finally {

            setLoading(false)

        }

    }

    const handleForgotPassword = () => {

        Modal.confirm({
            title: "Lupa Kata Sandi?",
            content: "Anda akan logout dari sistem dan harus login kembali.",
            okText: "Logout",
            cancelText: "Batal",
            okType: "danger",
            onOk: async () => {
                try {
                    await dispatch({ type: 'USER_LOGOUT' });
                    message.success('Logout berhasil');
                    history.push("/")
                } catch (error) {
                    message.error('Logout gagal: ' + (error.message || 'Unknown error'));
                }
            }
        })

    }

    return (

        <div style={styles.container}>

            <div style={styles.overlay} />

            <Card style={styles.card}>

                <Avatar
                    size={90}
                    src={Profile?.imageurl || "https://example.com/avatar.jpg"}
                    icon={<UserOutlined />}
                    style={styles.avatar}
                />

                <Title level={3} style={{ marginBottom: 0 }}>
                    {Profile?.nama_lengkap || Profile?.username || "Administrator"}
                </Title>

                <Text type="secondary">
                    {Profile?.level}
                </Text>
                <br />

                <Text type="secondary">
                    Layar Terkunci
                </Text>

                <Form layout="vertical" onFinish={onFinish}>
                    {Profile?.lock_screen?.require_password === 1 && (
                        <Form.Item
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: "Masukkan password untuk membuka layar"
                                }
                            ]}
                        >

                            <Input.Password
                                ref={inputRef}
                                size="large"
                                prefix={<LockOutlined />}
                                placeholder="Masukkan password"
                            />

                        </Form.Item>
                    )}


                    <Button
                        type="primary"
                        size="large"
                        htmlType="submit"
                        icon={<UnlockOutlined />}
                        loading={loading}
                        block
                    >
                        {Profile?.lock_screen?.require_password === 0 ? "Buka Layar Terkunci" : "Buka Kunci"}
                    </Button>

                    <Text
                        type="secondary"
                        style={{ cursor: "pointer" }}
                        onClick={handleForgotPassword}
                    >
                        Lupa kata sandi?
                    </Text>

                </Form>

            </Card>

        </div>

    )

}

const styles = {

    container: {
        height: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background:
            "url('https://images.unsplash.com/photo-1501785888041-af3ef285b470') center/cover",
        position: "relative"
    },

    overlay: {
        position: "absolute",
        inset: 0,
        backdropFilter: "blur(8px)",
        background: "rgba(0,0,0,0.35)"
    },

    card: {
        width: 380,
        borderRadius: 16,
        textAlign: "center",
        backdropFilter: "blur(14px)",
        background: "rgba(255,255,255,0.85)",
        boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
        zIndex: 10
    },

    avatar: {
        marginBottom: 16
    }

}

export default LockScreen